import { FC } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import BtButton from '../../../ts-components/bt-button/bt-button';
import appState from '../../../state/AppStateContainer';
import styles from './SimpleTaskCard.module.scss';

interface SimpleTaskCardProps extends RouteComponentProps {
  title: string;
  description: string;
  buttonText: string;
  icon: React.ComponentType<{ style?: React.CSSProperties }>;
  buttonIcon?: React.ComponentType<{ style?: React.CSSProperties }>;
  redirectTo?: string;
  onButtonClick?: () => void;
  notFill?: boolean;
  style?: React.CSSProperties;
}

const SimpleTaskCard: FC<SimpleTaskCardProps> = ({
  title,
  description,
  buttonText,
  icon: Icon,
  buttonIcon: ButtonIcon,
  redirectTo,
  onButtonClick,
  notFill = false,
  style,
  history
}) => {
  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else if (redirectTo) {
      const orgSlug = appState.getCurrentOrgSlug();
      history.push(`/${orgSlug}${redirectTo}`);
    }
  };

  return (
    <div className={styles.simpleTaskCard} style={style}>
      <div className={styles.taskContent}>
        <div className={`${styles.taskIcon} ${notFill ? styles.notFill : ''}`}>
          <Icon />
        </div>
        <div className={styles.taskRightSection}>
          <div className={styles.taskInfo}>
            <div className={styles.taskHeader}>
              <h3 className={styles.taskTitle}>
                {title}
              </h3>
            </div>
            <p className={styles.taskDescription}>
              {description}
            </p>
          </div>
          <div className={styles.taskButtonContainer}>
            <BtButton 
              onClick={handleButtonClick}
              color=""
              size="base"
            >
              {ButtonIcon && (
                <div className={styles.buttonIcon}>
                  <ButtonIcon />
                </div>
              )}
              {buttonText}
            </BtButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(SimpleTaskCard);
